import { type StrictColor, colorsPalettes } from "@similarweb/styles";
import { Flex, Text } from "@similarweb/ui-components/foundations";

import type { HealthSentiment } from "./health.types";

const SENTIMENT_BACKGROUND: Record<HealthSentiment, string> = {
    positive: colorsPalettes.green[100],
    negative: colorsPalettes.red[100],
    neutral: colorsPalettes.carbon[25],
};

const SENTIMENT_TEXT: Record<HealthSentiment, StrictColor> = {
    positive: colorsPalettes.green[600],
    negative: colorsPalettes.red[600],
    neutral: colorsPalettes.carbon[500],
};

interface IHealthSummaryBannerProps {
    title: string;
    sentiment: HealthSentiment;
}

export const HealthSummaryBanner = ({ title, sentiment }: IHealthSummaryBannerProps) => (
    <Flex
        justifyContent="center"
        padding="16px 24px"
        borderRadius="6px"
        background={SENTIMENT_BACKGROUND[sentiment]}
        data-automation="health-summary-banner"
    >
        <Text
            fontVariant="button"
            color={SENTIMENT_TEXT[sentiment]}
            textAlign="center"
        >
            {title}
        </Text>
    </Flex>
);
